import styled from 'styled-components';

const Container = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
`;

const Period = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;

  > div:nth-child(3n) {
    margin: 0 15px;
  }
`;

const Discount = styled.div`
  width: 56px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  border-radius: 5px;
  background-color: ${props => props.theme.color.green};
`;

export const Styled = {
  Container,
  Period,
  Discount,
};
